import React from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
const ProtectedRoute = ({ children }) => {
    const token = useSelector((state) => state.auth.token) || localStorage.getItem('accessToken');
    console.log("Token in ProtectedRoute: ", token);
    useEffect(() => {
        console.log("Token on render: ", token);
      }, [token]);
    return token ? children : <Navigate to="/signin"  />;
};

export default ProtectedRoute;
